import { setOptions, importLibrary } from "@googlemaps/js-api-loader"

// Single, shared Google Maps configuration for the whole app.
//
// We use the DYNAMIC key because it is the more-privileged browser key: it has
// access to BOTH the Maps JavaScript API (needed by every map hook) and the
// Places API (needed by the autocomplete hooks). The restricted FRONTEND key
// only has Places, so any map loaded under it throws ApiTargetBlockedMapError.
//
// Loading Maps JS through more than one mechanism / key used to race (see
// ENA-9514): whichever script won the race decided the page's key and library
// set. Everything now funnels through this one `setOptions` + `importLibrary`
// loader so Maps JS is fetched ONCE, with ONE key, and the needed libraries
// (`maps` for maps, `places`/`core` for autocomplete) are imported on demand.
//
// `v: "quarterly"` pins the API to the stable quarterly channel instead of the
// default `weekly` channel, removing surprise behavior changes from version
// drift.
setOptions({
  key: ENAIA_GOOGLE_MAPS_DYNAMIC_KEY,
  v: "quarterly",
})

// Object that mimics the v1 Loader interface for compatibility, so existing
// autocomplete hooks can keep calling googleMapsLoader.importLibrary("places").
export const googleMapsLoader = {
  importLibrary: (library) => importLibrary(library),
}

// Compatibility helper for the map hooks, which previously loaded Maps JS via a
// legacy script tag (window.Enaia.loadGoogleMaps). Routing them through the same
// importLibrary loader keeps a single bootstrap and a single key. The key now
// comes from setOptions above, so any caller-supplied key argument is ignored.
export function loadGoogleMaps() {
  return importLibrary("maps")
}

// The single build-time DYNAMIC key, exposed for consumers that need to set the
// key directly rather than via setOptions — specifically the Cesium
// photorealistic 3D tile hooks, which assign Cesium.GoogleMaps.defaultApiKey.
// Surfaced on window.Enaia in app.js so the colocated 3D/map hooks can read it
// (they used to read it from a data-api-key attribute, now removed).
export const googleMapsDynamicKey = ENAIA_GOOGLE_MAPS_DYNAMIC_KEY
